import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.batch,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.batch) = $event)),
        modelModifiers: { trim: true },
        placeholder: "批次号",
        clearable: "",
        style: {"width":"160px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select_v2, {
        class: "filter-item",
        filterable: "",
        modelValue: _ctx.filters.sale_channel_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.sale_channel_id) = $event)),
        clearable: "",
        options: _ctx.saleChannelList,
        props: _ctx.saleListProps,
        placeholder: "请选择销售渠道名称"
      }, null, 8, ["modelValue", "options", "props"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.coupon_no,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.coupon_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "卡券码",
        clearable: "",
        style: {"width":"160px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.binding_rate,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.binding_rate) = $event)),
        modelModifiers: { trim: true },
        placeholder: "绑定率大于",
        clearable: "",
        style: {"width":"160px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.consumption_rate,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.consumption_rate) = $event)),
        modelModifiers: { trim: true },
        placeholder: "消耗率大于",
        clearable: "",
        style: {"width":"160px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.start_valid_at,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.start_valid_at) = $event)),
        placeholder: "激活开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: _ctx.filters.end_valid_at,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.end_valid_at) = $event)),
        placeholder: "激活结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearch()))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onExport()))
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "batch",
          label: "批次号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sale_channel",
          label: "渠道名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_total_number",
          label: "卡券总张数"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_total_face",
          label: "卡券总面值"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_binding_number",
          label: "绑定张数"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_binding_face",
          label: "绑定总面值"
        }),
        _createVNode(_component_el_table_column, { label: "绑定率" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.binding_rate + '%'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_consumption_face",
          label: "消耗总金额"
        }),
        _createVNode(_component_el_table_column, { label: "消耗率" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.consumption_rate + '%'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "批次毛利率" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.gross_profit_margin + '%'), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_Pagination, {
      currentPage: _ctx.filters.page,
      total: _ctx.total,
      onPageChange: _ctx.onPageChange,
      onSizeChange: _ctx.onSizeChange
    }, null, 8, ["currentPage", "total", "onPageChange", "onSizeChange"])
  ]))
}